import { render, staticRenderFns } from "./AscPowerBiMyAirlineWorkspaceWrapper.vue?vue&type=template&id=3d1f88e2&"
import script from "./AscPowerBiMyAirlineWorkspaceWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPowerBiMyAirlineWorkspaceWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPowerBiMyAirlineWorkspaceWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports